import { useEffect } from 'react'

import { useScript } from '../../hooks/useScript'
import style from '../../styles/Weather/weather_radar_map'
import Title from './Title'

// Scripts and the icon sprite the wxWidget loader injects; it adds new copies on every mount
const WX_WIDGET_INJECTED = 'script[src*="wxwidget"], #wx-icons-sprite'

const WeatherRadarMap = ({ latitude, longitude, zoom }) => {
  const status = useScript(`https://widgets.media.weather.com/wxwidget.loader.js?cid=626796161`, {
    removeOnUnmount: true
  })

  useEffect(() => {
    if (status === 'loading') {
      window.wxWidgets = null
    }
  }, [status])

  useEffect(() => {
    return () => {
      document.querySelectorAll(WX_WIDGET_INJECTED).forEach(element => element.remove())
    }
  }, [])

  return (
    <div className='radar-map-container'>
      <Title title='Radar Map' />
      <div className='map'>
        <wx-widget
          type='map'
          memberId='0013'
          mapId='0001'
          latitude={latitude?.toString()}
          longitude={longitude?.toString()}
          zoomlevel={zoom?.toString()}
          fullscreen='true'
        />
      </div>
      <style jsx>{style}</style>
    </div>
  )
}
export default WeatherRadarMap
